import {APP_KAYAK_BIDDING_API_ENDPOINT} from "../../../../../constants/api_urls";

export const apiUrlActiveMultipliers = {
    // TODO @mehdi put the correct end of api
    'get': {
        "extra_bid": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-extra-bid/`,
        "max_bid": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-max-bid/`,
        "weekend_stay": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-multipliers-weekend-stay/`,
        "days_to_arrival": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-multipliers-days-to-arrival/`,
        "length_of_stay": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-multipliers-length-of-stay/`,
        "market_bids": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-market-bid/`,
    },
    'delete': {
        "hotels": {
            "extra_bid": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/hotels/active-multipliers-device/`,
            "weekend_stay_multipliers": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/hotels/weekend_stay/`,
            "days_to_arrival_multipliers": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/hotels/days-to-arrival/`,
            "length_of_stay_multipliers": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/hotels/length-of-stay/`,
            "market_bids": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/hotels/market_bids/`,
        },
        "groups": {
            "extra_bid": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/groups/active-multipliers-device/`,
            "weekend_stay_multipliers": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/groups/weekend_stay/`,
            "days_to_arrival_multipliers": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/groups/days-to-arrival/`,
            "length_of_stay_multipliers": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/groups/length-of-stay/`,
            "market_bids": `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/bidding/delete/groups/market_bids/`,
        }
    }
};